var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckedBlack = function SvgCheckedBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5BF9\u52FE-\u9ED1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u89C4\\u8303",
    transform: "translate(-999.000000, -4795.000000)",
    fill: "#2C2E3B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BF9\\u52FE-\\u9ED1",
    transform: "translate(999.000000, 4795.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26970381,4.71532598 C1.61486417,4.37016562 2.15849067,4.35417661 2.48392758,4.67961351 L4.80523772,7.00092366 L9.52369087,2.2824705 C9.53132307,2.27423922 9.53914152,2.26611854 9.54714623,2.25811383 C9.89230659,1.91295347 10.4530813,1.91411267 10.7996716,2.26070298 C11.1462619,2.60729329 11.1474211,3.16806801 10.8022608,3.51322836 C10.7761577,3.53933145 10.7488214,3.56345384 10.7204379,3.58559591 L5.47660634,8.7664892 C5.08540761,9.15299263 4.45553285,9.15109124 4.06667468,8.76223307 L1.23399135,5.92954974 L1.23399135,5.92954974 C0.90855444,5.60411283 0.924543454,5.06048634 1.26970381,4.71532598 Z",
    id: "Path"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checked-black.66be2aee.svg";